import type {
  CanonicalTreeExternalEvidenceContextState,
} from './CanonicalTreeExternalEvidenceContextAdoptionSimulation';

export interface CanonicalTreeExternalEvidenceObservabilitySummary {
  readonly status:
    CanonicalTreeExternalEvidenceContextState['snapshot']['status'];

  readonly ownerUserId:
    string | null;

  readonly memberCount:
    number;

  readonly refreshReason:
    CanonicalTreeExternalEvidenceContextState['snapshot']['refreshReason'];

  readonly lastAttemptStatus:
    CanonicalTreeExternalEvidenceContextState['lastAttempt'] extends
      infer T
      ? T extends {
          readonly status:
            infer S;
        }
        ? S | null
        : null
      : null;

  readonly readyForGateway:
    boolean;

  readonly error:
    string | null;

  readonly action:
    CanonicalTreeExternalEvidenceContextState['action'];
}

export const summarizeCanonicalTreeExternalEvidenceContext = (
  state:
    CanonicalTreeExternalEvidenceContextState,
): CanonicalTreeExternalEvidenceObservabilitySummary =>
  Object.freeze({
    status:
      state.snapshot.status,

    ownerUserId:
      state.ownerUserId,

    memberCount:
      state.members.length,

    refreshReason:
      state.snapshot.refreshReason,

    lastAttemptStatus:
      state.lastAttempt?.status ??
      null,

    readyForGateway:
      state.snapshot.readyForGateway,

    error:
      state.snapshot.error,

    action:
      state.action,
  });
